import {map, share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ApiService} from './api';
import {Observable, of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TailsService {
  path: string = '/api';
  tails: any = null;
  partnerId: number | null = null;
  constructor(private apiService: ApiService) {}

  private observable: Observable<any> | null = null;

  getTails(partnerId: number) {
    if (partnerId === this.partnerId && this.tails) {
      return of(this.tails);
    } else if (this.observable) {
      return this.observable;
    } else {
      this.observable = this.apiService.get(`${this.path}/partners/${partnerId}/tails`).pipe(
        map((response: any) => {
          this.observable = null;
          this.partnerId = partnerId;
          this.tails = response;
          return this.tails;
        }),
        share(),
      );
      return this.observable;
    }
  }
}
